<template lang="pug">
  bloco.-withpadding
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Notícias
      small.more(v-if="reference"): router-link(:to="{ name: 'Noticias' }") Ver tudo
    //- CONTENT
    .conteudo(slot="content")
      noticias-lista(:noticias="noticias" v-if='!naoTemNoticias')
    //- FOOTER
    footer(slot="footer" v-if="perPage < totalNoticias && !reference")
      br
      hr.-normal
      paginacao(
      v-if="pagination",
        :gender='"a"',
        :object='"notícias"',
        :total='totalNoticias',
        :totalPage='totalPages',
        :perPage='perPage',
        :perPageAtual='noticias.length',
        :pageAtual="page")
    //- FEEDBACK
    template(slot="feedback" v-if='naoTemNoticias')
      mensagem.-warn
        p Nenhuma notícia foi encontrada no momento
</template>

<style lang="scss">
  .noticias-lista {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .noticia-item {
    margin-bottom: 20px;
    width: 100%;

    &:last-child { margin-bottom: 0; }

    > .imagem {
      width: 100%;
      height: 0;
      padding-bottom: 50%;
      margin-bottom: 15px;
      border-radius: 5px;
      @extend %imagem_proporcional;
      img { border-radius: 5px; }
    }

    > .detalhe {
      width: 100%;
      > .titulo > h3 { width: 100%; }
      > .titulo > h3:hover { color: $color-blue-light }
      > .data { position: relative; width: 100px; }
      > .tags { width: 100%; }
    }

    .tag {
      margin: 5px 5px 5px 0;
      margin-bottom: 10px;
      padding: 3px 9px;
      border-radius: 5px;
      float: left;

      &.first {
        background-color: $color-blue-dark;
        color: $color-neutral !important;
      }

      &:not(.first) {
        text-transform: lowercase;
        background-color: $color-green-light;
      }

      &:not(.first):hover {
        background-color: $color-green-dark !important;
        color: $color-neutral !important;
      }
    }

    @include media(">=tablet") {
      > .imagem {
        width: 250px;
        height: 130px;
        padding: 0;
        margin-right: 30px;
        float: left;
      }

      > .detalhe {
        padding-left: 280px;
      }
    }

    @include media(">=desktop") {
      .tag { padding: 1px 9px }
    }
  }
</style>

<script>
  import Bloco from 'COMPONENTS/Bloco'
  import Mensagem from 'COMPONENTS/Mensagem'
  import NoticiasLista from 'COMPONENTS/NoticiasLista'
  import Paginacao from 'COMPONENTS/Paginacao'
  import Titulo from 'COMPONENTS/ElementTitle'
  import NoticiasService from '../../js/api/NoticiaService'
  import Utils from '../../js/utils'

  export default {

    components: {
      Bloco,
      Mensagem,
      NoticiasLista,
      Paginacao,
      Titulo
    },

    props: {
      reference: { type: Boolean, required: false },
      pagination: { type: Boolean, required: false },
      perPage: { type: Number, required: false }
    },

    data: function () {
      return {
        noticias: [],
        totalNoticias: 0,
        totalPages: 0,
        naoTemNoticias: false,
        page: 1,
        tag: ''
      }
    },

    methods: {
      loadNoticias (perPage = 4, page = 1, tag = '') {
        let noticiasTratadas = []
        NoticiasService.getNoticias(perPage, page, tag)
        .then(noticiasDados => {
          noticiasDados.data.forEach(function (noticia) {
            let tagsAtual = []
            if (noticia.tags.length > 0) {
              noticia._embedded['wp:term'][0].forEach(function (term) {
                tagsAtual.push({
                  id: term.id,
                  nome: term.name,
                  slug: term.slug
                })
              })
            }
            let noticiaTratada = {
              id: noticia.id,
              titulo: noticia.title.rendered,
              data_publicacao: Utils.dataFormatada(noticia.acf.data_de_publicacao * 1000),
              url: noticia.slug,
              cover: (noticia.featured_media) ? Utils.trataMiniatura(noticia._embedded['wp:featuredmedia'][0]).source_url : 'static/imagem_padrao.jpg',
              tags: tagsAtual
            }
            noticiasTratadas.push(noticiaTratada)
          })
          this.totalNoticias = parseInt(noticiasDados.headers['x-wp-total'])
          this.totalPages = parseInt(noticiasDados.headers['x-wp-totalpages'])
          if (noticiasTratadas.length === 0) {
            this.naoTemNoticias = true
          }
        })
        return noticiasTratadas
      }
    },

    watch: {
      page: function () {
        this.noticias = this.loadNoticias(this.perPage, this.page, this.tag)
      },
      tag: function () {
        this.noticias = this.loadNoticias(this.perPage, this.page, this.tag)
      }
    },

    mounted () {
      this.page = (this.$route.params.page) ? this.$route.params.page : 1
      this.tag = (this.$route.params.tag) ? this.$route.params.tag : ''
      this.noticias = this.loadNoticias(this.perPage, this.page, this.tag)
    },

    beforeUpdate () {
      this.page = (this.$route.params.page) ? this.$route.params.page : 1
      this.tag = (this.$route.params.tag) ? this.$route.params.tag : ''
    }
  }
</script>



// WEBPACK FOOTER //
// Noticias.vue?35d05bfd